var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsumptionLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 34,
    viewBox: "0 0 40 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C14.8693 0 9.74835 1.90476 5.84901 5.70476C-1.94967 13.3048 -1.94967 25.6857 5.84901 33.2857C6.82629 34.2381 8.40948 34.2381 9.38676 33.2857C10.364 32.3333 10.364 30.7905 9.38676 29.8381C3.50354 24.1048 3.50354 14.8857 9.38676 9.15238C15.27 3.41905 24.73 3.41905 30.6132 9.15238C35.5485 13.9619 36.3401 21.2286 32.9978 26.819C32.3528 27.9048 31.5612 28.9143 30.6132 29.8381C29.636 30.7905 29.636 32.3333 30.6132 33.2857C31.5905 34.2381 33.1737 34.2381 34.151 33.2857C41.9497 25.6857 41.9497 13.3048 34.151 5.70476C30.2516 1.90476 25.1307 0 20 0ZM32.9978 26.819L32.0889 23.4952L25.0037 19.5048C25.0037 17.7619 24.0459 16.1619 22.5018 15.2857C20.1075 13.9429 17.0486 14.7429 15.6707 17.0667C14.2829 19.4 15.1038 22.3905 17.4982 23.7333C19.0423 24.6 20.948 24.5905 22.4921 23.7238L29.5871 27.7143L32.9978 26.819Z",
    fill: "url(#paint0_linear_75_518)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_518",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEC53D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumptionLogo);
export default __webpack_public_path__ + "static/media/Consumption Logo.08332a67d6f44bea9a85227628c535de.svg";
export { ForwardRef as ReactComponent };